import { chatRoute } from '@townsquare/routes/chat';
import { createAgentRoute } from '@townsquare/routes/create-agent';
import { editAgentRoute } from '@townsquare/routes/edit-agent';
import { rovoEntitlementResource } from '@townsquare/rovo/entitlement';

import { ChatLoadable } from './components/ChatView';
import { CreateAgentLoadable } from './components/CreateAgentView';
import { EditAgentLoadable } from './components/EditAgentView';

chatRoute.component = ChatLoadable;
chatRoute.resources = [rovoEntitlementResource];
export const chatRouterRoute = chatRoute;

createAgentRoute.component = CreateAgentLoadable;
createAgentRoute.resources = [rovoEntitlementResource];
export const createAgentRouterRoute = createAgentRoute;

editAgentRoute.component = EditAgentLoadable;
editAgentRoute.resources = [rovoEntitlementResource];
export const editAgentRouterRoute = editAgentRoute;

export const isInRovoFullscreenPages = (routeName: string): boolean =>
	routeName === chatRoute.name ||
	routeName === createAgentRoute.name ||
	routeName === editAgentRoute.name;
